<style lang="scss" scoped>
.mainbox {
  border-radius: 3px;

  ul {
    overflow: hidden;
    padding: 10px;

    dd {
      width: 13.6%;
      float: left;
      text-align: right;
      font-size: 14px;
    }

    li {
      padding: 10px;
      width: 13.6%;
      float: left;
      border-top: 2px solid #DCDFE6;

      &.yiman {
        background-color: rgba(0, 0, 0, 0.04);
      }

      &.isCurrMonth.isOver {
        background-color: rgba(0, 0, 0, 0.04);
      }
    }

    .l {
      margin-left: 0.8%;
    }

    .t {
      margin-top: 10px;
    }

    .isCurrMonth {
      p {
        color: rgba(0, 0, 0, 0.65);
      }
    }

    p {
      color: rgba(0, 0, 0, 0.25);
      font-size: 14px;
      text-align: right;
    }

    section {
      font-size: 14px;
      line-height: 25px;
      color: rgba(0, 0, 0, 0.65);
      display: flex;
      align-items: center;

      font {
        margin-right: 5px;
        display: block;
        width: 4px;
        height: 4px;
        border-radius: 2px;
      }

      .c1 {
        background-color: #52C41A;
      }

      .c2 {
        background-color: #FAAD14;
      }
    }
  }
}
</style>
<template>
  <div>
    <tj-title-bar :title="healthcheckBookTeam.teamName" :content="rangeText">
      <p slot="right">
        <span class="fs16">{{ currYear }}</span>
      </p>
    </tj-title-bar>

    <div class="mainbox mt15 bg_fff">
      <section class="bb pl15 pr15 pt10 pb10 flex aic">
        <p class="fs14 flex1">
          总人数：{{ total.healthcheckUserCount }}人
          已预约人数：<span class="color_green">{{ total.waitCheckCount }}</span>人
          未预约人数：<span class="color_red">{{ total.waitHandleCount }}</span>人
          已到检人数：<span class="color_main">{{ total.alredayCheckCount }}</span>人
        </p>
        <p class="flex0">
          <el-button size="mini" @click="handler">今天</el-button>
          <el-button size="mini" icon="el-icon-arrow-left" @click="handler('-')"></el-button>
          <el-button size="mini" icon="el-icon-arrow-right" @click="handler('+')"></el-button>
          <span class="fs14 ml10">{{ currYear }}年{{ currMonth }}月</span>
        </p>
      </section>
      <ul>
        <dd v-for="(data,idx) in week" :key="'dd'+idx" :class="[idx%7>0?'l':'']">{{ data }}</dd>
        <li :class="[idx%7>0?'l':'',idx>6?'t':'',data.isCurrMonth?'isCurrMonth':'',data.numberSourceTotal===0?'yiman':'',data.isOver?'isOver':'']"
            v-for="(data,idx) in range"
            :key="idx" @click="detail(data)">
          <p>{{ data.day }}</p>
          <template v-if="data.isCurrMonth">
            <div v-if="data.numberSourceTotal>0">
              <section class="mt30">
                <font class="c1"></font>已预约{{ data.bookedNumberSourceTotal }}
              </section>
              <section>
                <font class="c2"></font>剩余{{ data.surplusNumberSourceTotal || 0 }}/总{{ data.numberSourceTotal }}
              </section>
            </div>
            <div v-else>
              <section class="mt55">
                <font class="c2"></font>总{{ data.numberSourceTotal }}
              </section>
            </div>
            <!--<section class="mt30" v-if="data.surplusNumberSourceTotal>0">
                <font class="c1"></font>已预约{{data.bookedNumberSourceTotal}}
            </section>
            <section v-if="data.surplusNumberSourceTotal>0">
                <font class="c2"></font>剩余{{data.surplusNumberSourceTotal||0}}/总{{data.numberSourceTotal}}
            </section>
            <section class="mt55" v-if="data.numberSourceTotal===0">
                <font class="c2"></font>总{{data.numberSourceTotal}}
            </section>
            <section class="mt55" v-else>
                <font class="c2"></font>剩余{{data.surplusNumberSourceTotal||0}}/总{{data.numberSourceTotal}}
            </section>-->
          </template>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import TjTitleBar from "../components/tj-title-bar";
import dayjs from 'dayjs'
import {timeFormat} from "../../../common/lib/utils";
import {healthcheckService} from "../services/healthcheck";
import {riliItemCacheKey} from "../config";
import {RiliMixin} from "../mixin";

export default {
  name: 'tj-rili',
  filters: {timeFormat},
  components: {TjTitleBar},
  mixins: [RiliMixin],
  data() {
    return {
      data: [],
      total: {},
      list: []
    }
  },
  computed: {
    rangeText() {
      const {startDate, endDate} = this.healthcheckBookTeam;
      const format = 'YYYY-MM-DD';
      return `预约日期范围：${dayjs(startDate).format(format)}~${dayjs(endDate).format(format)}`;
    },
    range() {
      const now = dayjs().startOf('day');
      const {start, end, curr, data} = this;
      let s = start.valueOf(), e = end.valueOf();
      let arr = [];
      while (s <= e) {
        let day = dayjs(s);
        let date = day.format('YYYY-MM-DD');
        let d = data.find(r => r.date === date) || {};
        arr.push({
          date,
          ...d,
          day: day.format('DD'),
          month: day.month(),
          isOver: day.valueOf() < now.valueOf(),
          isCurrMonth: day.month() === dayjs(curr).month()
        });
        s += 24 * 3600 * 1000;
      }
      return arr;
    }
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      const month = dayjs(this.curr).format('YYYY-MM');
      const teamId = this.healthcheckBookTeam.id;
      this.data = await healthcheckService.tjhyList(month, teamId);
      this.total = await healthcheckService.tjhyTotal(teamId);
    },
    detail(data) {
      this.$cache.set(riliItemCacheKey, data);
      if (data.numberSourceTotal === 0) return;
      this.$router.push({
        path: '/tj/list',
        query: {
          date: data.date
        }
      })
    },
    handler(type) {
      this.handlerRili(type);
      this.getData();
    }
  },
}
</script>
